// Author Pan Yu Rou
// Date 2022-11-29 16:20:11

class SithMesPrdInfoRecord {
constructor({
        id = null,
        moduleType = '',
        key = '',
        oldValue = '',
        newValue = '',
        remark = ''}
= {}) {
    this.id = id;
    this.moduleType = moduleType;
    this.key = key;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdInfoRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'moduleType',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.moduleType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'STOOL_PR' },
                            { value: '2', text: 'STOOL_PO' },
                            { value: '3', text: 'PROJECT_KAM_EDIT' }
            ]
        }
        },
        {
        key: 'key',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.key',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.oldValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'newValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.newValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}
const subviewVoConfigs = [
        {
        key: 'oldValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.oldValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'newValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.newValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdInfoRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    moduleTypeFilter : '',
    keyFilter : '',
    oldValueFilter : '',
    newValueFilter : '',
    dateFromFilter : '',
    dateEndFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'moduleTypeFilter',
        label: 'label.sith.prd.sithMesPrdInfoRecord.filter.moduleType',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'keyFilter',
        label: 'label.sith.prd.sithMesPrdInfoRecord.filter.key',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldValueFilter',
        label: 'label.sith.prd.sithMesPrdInfoRecord.filter.oldValue',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newValueFilter',
        label: 'label.sith.prd.sithMesPrdInfoRecord.filter.newValue',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'moduleType',
        label: 'label.sith.prd.sithMesPrdInfoRecord.entity.moduleType',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'key',
        label: 'label.sith.prd.sithMesPrdInfoRecord.entity.key',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.entity.oldValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newValue',
        label: 'label.sith.prd.sithMesPrdInfoRecord.entity.newValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdInfoRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdInfoRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs

, subviewVoConfigs
}
